import React from "react";
import clientConfig from "../../client-config";
import PortableText from "./portableText";
import * as styles from './contactForm.module.css';


function ContactForm(props) {
    
    let bgColor = (props.bgcolor) ? props.bgcolor.hex : '#FFFFFF';

    return (
        <div className={styles.sectionContactForm} style={{ backgroundColor: `${bgColor}`}}>
            <div className={styles.sectionContainer}>
                <div className={styles.sectionContent}>
                    <h3>{props.heading}</h3>
                    <div className={styles.contentWrap}>
                        <PortableText blocks={props.content} />
                    </div>
                    {
                        (props.contact) ? 
                            <a href={`tel:`+props.contact} target="_blank" className={styles.contactNumber}>{props.contact}</a>
                            : ``
                    }
                    <div className={styles.socialLinks}>
                        {
                            (props.iglink) ? 
                                <a href={props.iglink} target="_blank">
                                    <i class="fab fa-instagram"></i>
                                </a>
                                : ``
                        }
                        {
                            (props.fblink) ? 
                                <a href={props.fblink} target="_blank">
                                    <i class="fab fa-facebook-f"></i>
                                </a>
                                : ``
                        }
                        {
                            (props.ytlink) ? 
                                <a href={props.ytlink} target="_blank">
                                    <i class="fab fa-youtube"></i>
                                </a>
                                : ``
                        }
                        {
                            (props.linkedinlink) ? 
                                <a href={props.linkedinlink} target="_blank">
                                    <i class="fab fa-linkedin"></i>
                                </a>
                                : ``
                        }
                    </div>
                </div>
                <div className={styles.formWrapper}>
                    <form>
                        <input type="email" name="email" placeholder="Email" className={styles.formEmail} required />
                        <input type="text" name="subject" placeholder="Subject" className={styles.formSubject} required />
                        <textarea name="message" placeholder="Message" className={styles.formMessage}></textarea>
                        <div className={styles.submitWrap}>
                            <button type="submit" className={styles.formSubmit}>
                                <span class="inline-block align-middle">Send Message</span>
                                <img class="inline-block align-middle" src={require('../images/arrow-right-white.png').default} alt="Right arrow" />
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
  
export default ContactForm;